// extracted by mini-css-extract-plugin
module.exports = {"component":"MinableCard_component__2Orsg","collapsed":"MinableCard_collapsed__3PxK4","collapseButton":"MinableCard_collapseButton__1pvHk"};